import { useMemo } from 'react';
import { RequestLog } from '../../api/vault';
import * as S from './styles';

interface Props {
	log: RequestLog | null;
}

const formatJson = (value: string): string => {
	try {
		return JSON.stringify(JSON.parse(value), null, 2);
	} catch {
		return value;
	}
};

const LogDetail = ({ log }: Props) => {
	//--- HOOKS
	const formattedValue = useMemo(() => (log ? formatJson(log.value) : ''), [log]);

	//--- RENDERING
	if (!log) {
		return <S.EmptyState>Select a log entry to view details</S.EmptyState>;
	}

	return (
		<S.DetailContainer>
			<S.DetailJson>{formattedValue}</S.DetailJson>
		</S.DetailContainer>
	);
};

export default LogDetail;
